import axiosInstance from "./api_helper";

const unwrap = (response) => response.data?.body ?? response.data;

const userService = {
    search: async (query = "") => {
        const response = await axiosInstance.get("/api/users", {
            params: { query },
        });
        return unwrap(response);
    },

    create: async (payload) => {
        const response = await axiosInstance.post("/api/users", JSON.stringify(payload));
        return unwrap(response);
    },

    update: async (id, payload) => {
        const response = await axiosInstance.put(`/api/users/${id}`, JSON.stringify(payload));
        return unwrap(response);
    },

    setEnabled: async (id, enabled) => {
        const response = await axiosInstance.patch(`/api/users/${id}/enabled`, JSON.stringify({ enabled }));
        return unwrap(response);
    },
};

export default userService;
